import punycode from 'punycode/';

// Matches strings containing Æ-Ø-Å
const excludeNorwegianLetterRegex = /^((?![æøå]).)*$/i;
export const excludeNorwegianLettersStringPattern = '^((?![æÆøØåÅ]).)*$';

// Matches strings following email address pattern - https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/email#validation
const emailRegex =
  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

const validateEmailByRegex = (email: string) =>
  excludeNorwegianLetterRegex.test(email) && emailRegex.test(email);

// Derived from backend validation
const validateThatEmailIsASCII = (email: string) => {
  const index = email.indexOf('@');
  const url = punycode.toUnicode(email.substr(index + 1));
  const str = `${email.substr(0, index + 1)}${url}`;

  for (let n = 0; n < str.length; n++) {
    if (str.charCodeAt(n) > 127) return false;
  }

  return true;
};

const validateEmail = (email: string) =>
  validateEmailByRegex(email) && validateThatEmailIsASCII(email);

export default validateEmail;
